<template>
	<div>
		<!-- ------------------------------密碼修改開始------------------------------ -->
        <div class="modal fade cm-modal" id="changePasswordModal" tabindex="-1" role="dialog"
            aria-labelledby="registerModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered cm-modal-changePassword" role="document">
                <div class="modal-content">
                    <div class="modal-header p-0 text-center cm-modal-changePasswordModal-header">
                        <h4 class='col-12 modal-title text-center text-white'>
                            {{$t('modal.ChangePassword.Title')}}
                            <button type="button" class="close cm-changePassword-close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">
                                    <img src="@/assets/images/login-close.png">
                                </span>
                            </button>
                        </h4>
                    </div>
                    <div class="modal-body pb-5 cm-modal-changePasswordModal-body">
                        <div class="col-12 px-sm-3 p-0 pt-5 row no-gutters">
                            <div class="col-12 px-sm-3 px-0 form-group row">
                                <label for="" class="col-sm-5 col-form-label text-sm-right">{{$t('modal.ChangePassword.Input.NewPassword')}}</label>
                                <div class="col-sm-7">
                                    <input type="password" class="form-control" maxlength="20" v-model="inputNewPassword" v-on:blur="newPasswordInputMonitor">
                                    <span class="text-danger" v-if="newPasswordPromptString !== ''">{{newPasswordPromptString}}</span>
                                </div>
                            </div>
                            <div class="col-12 px-sm-3 px-0 form-group row">
                                <label for="" class="col-sm-5 col-form-label text-sm-right">{{$t('modal.ChangePassword.Input.ConfirmNewPassword')}}</label>
                                <div class="col-sm-7">
                                    <input type="password" class="form-control" maxlength="20" v-model="inputConfirmPassword" v-on:blur="confirmPasswordInputMonitor">
                                    <span class="text-danger" v-if="confirmPasswordPromptString !== ''">{{confirmPasswordPromptString}}</span>
                                </div>
                            </div>
                            <div class="col-12 mt-sm-5 mt-0 mb-4 row no-gutters">
                                <div v-if="domControl.isWaitingChangePassword==true" class="col-sm-6 col-12 px-3 my-1 text-center">
                                    <div class="spinner-border text-warning text-center my-2" role="status"></div>
                                </div>
                                <div v-else class="col-sm-6 col-12 px-3 my-1 d-flex justify-content-center justify-content-sm-end">
                                    <button class="btn w-75" @click="submitBtn">{{$t('modal.ChangePassword.Button.Confirm')}}</button>
                                </div>
                                <div class="col-sm-6 col-12 px-3 my-1 d-flex justify-content-center justify-content-sm-start">
                                    <button class="btn w-75">{{$t('modal.ChangePassword.Button.Cancel')}}</button>
                                </div>
                            </div>
                        </div>
                        <img src="@/assets/images/cmi_logo_black.png" class="cm-changePasswordModal-logo-img">
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------密碼修改結束------------------------------ -->
	</div>
</template>

<script>

import $ from "jquery";
import axios from "axios";
import router from '@/router'
import eventBus from "@/assets/js/event/EventBus.js";
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js"
import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'

export default {
    data() {
        return {
            changePasswordKey: "",
            inputNewPassword: "",
            newPasswordPromptString: "",
            inputConfirmPassword: "",
            confirmPasswordPromptString: "",
            domControl: {
                isWaitingChangePassword: false
            }
        }
    },
    mounted() {
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_MEMBER_PASSWORD, function(i18n, changePasswordKey) {
            self.changePasswordKey = changePasswordKey;
            self.eventBusOpenPasswordlModal(i18n);
        });
    },
    methods: {
        async eventBusOpenPasswordlModal(i18n = this.$i18n) {
            const result = await this.checkSetPasswordKey();
            if(result) {
                // 若"輸入新密碼"、"再次輸入新密碼"的提示不為空，表示之前有輸入過，此時modal開啟前再check一次(當語系有換過時，此法可以順便更換字串到對應語系)
                if(this.newPasswordPromptString!="" || this.confirmPasswordPromptString!="") {
                    this.checkPassword()
                }
                $("#changePasswordModal").modal("show");
            }
            else {
                alert(i18n.t('modal.ChangePassword.Alert.Error.ChangePasswordKey'));
            }
        },
        async checkSetPasswordKey() {
            let result = false;
            if(this.changePasswordKey!="" && this.changePasswordKey!=undefined && this.changePasswordKey!=null) {
                const self = this;
                const response = await axios({
                    method: "get",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/checkSetPasswordKeyAction.shtml?key=" + self.changePasswordKey + "&_=" + new Date().getTime()
                })
                .catch(function() {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                })

                // 判斷Ajax結果
                if(response!=null && response!=undefined) {
                    if(response.data.result=="success") {
                        result = true;
                    }
                    else { // key判斷結果不為success時
                        this.changePasswordKey = ""; // key失效，清空
                    }
                }
            }
            return result;
        },
        newPasswordInputMonitor() {
            // 驗證字串長度
            this.newPasswordPromptString = ValidatorUtil.validLength(this.inputNewPassword, {
                'req': this.$i18n.t('modal.ChangePassword.Validate.NewPassword.req'),
                'maxLen': this.$i18n.t('modal.ChangePassword.Validate.NewPassword.maxLen'),
                'minLen': this.$i18n.t('modal.ChangePassword.Validate.NewPassword.minLen')
            });
            if(ValidatorUtil.isLengthMeet(this.inputNewPassword)) {
                // 驗證字串為英數
                this.newPasswordPromptString = ValidatorUtil.validEngNumOnly(this.inputNewPassword, {
                    'engNumOnly': this.$i18n.t('modal.ChangePassword.Validate.NewPassword.engNumOnly')
                })
            }
        },
        confirmPasswordInputMonitor() {
            // 驗證字串長度
            this.confirmPasswordPromptString = ValidatorUtil.validLength(this.inputConfirmPassword, {
                'req': this.$i18n.t('modal.ChangePassword.Validate.ConfirmPassword.req'),
                'maxLen': this.$i18n.t('modal.ChangePassword.Validate.ConfirmPassword.maxLen'),
                'minLen': this.$i18n.t('modal.ChangePassword.Validate.ConfirmPassword.minLen')
            });

            if(ValidatorUtil.isLengthMeet(this.inputConfirmPassword)) {
                // 驗證字串為英數
                this.confirmPasswordPromptString = ValidatorUtil.validEngNumOnly(this.inputConfirmPassword, {
                    'engNumOnly': this.$i18n.t('modal.ChangePassword.Validate.ConfirmPassword.engNumOnly')
                })
                if(this.confirmPasswordPromptString != "" ) {
                    return;
                }

                // 比對密碼、確認密碼是否相符
                if(ValidatorUtil.isLengthMeet(this.inputNewPassword) && this.inputNewPassword!==this.inputConfirmPassword) {
                    this.confirmPasswordPromptString = this.$i18n.t('modal.ChangePassword.Validate.ConfirmPassword.notEqual');
                }
                else {
                    this.confirmPasswordPromptString = "";
                }
            }
        },
        checkPassword() {
            this.newPasswordInputMonitor();
            this.confirmPasswordInputMonitor();
        },
        async submitBtn() {
            const result = await this.checkSetPasswordKey();
            if(result == false) {
                alert(this.$i18n.t('modal.ChangePassword.Alert.Error.ChangePasswordKey'));
            }
            else {
                this.checkPassword()
                if(this.newPasswordPromptString=="" && this.confirmPasswordPromptString=="") {
                    RecaptchaUtil.startGoogleRecaptchaVerify(process.env.VUE_APP_AUTH_RECAPTCHA_CHANGE_PASSWORD, this.ajaxChangePasswordJsonAction);
                }
            }
        },
        async ajaxChangePasswordJsonAction(gRecaptchaResponse) {
            let bodyFormData = new FormData();
            bodyFormData.append("key", this.changePasswordKey);
            bodyFormData.append("password", this.inputNewPassword);
            bodyFormData.append("mydomain", "all9fun.com");
            bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);

            // 開啟Ajax等待動畫
            this.domControl.isWaitingChangePassword = true

            // Ajax
            const response = await axios({
                method: "post",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/changePasswordJsonAction.shtml",
                data: bodyFormData
            })
            .catch(function() {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
            })

            // 關閉Ajax等待動畫
            this.domControl.isWaitingChangePassword = false
    
            // 判斷Ajax結果
            if(response!=null && response!=undefined) {
                if(response.data.result=="success") { // key判斷結果為success時
                    this.changePasswordKey = "";
                    alert(this.$i18n.t('modal.ChangePassword.Backend.Response.changeSuccess'));
                    if(router.currentRoute.name != process.env.VUE_APP_ROUTER_HOME) {
                        location.href = "/";
                    }
                    else {
                        $("#changePasswordModal").modal("hide");
                    }
                }
                else {
                    alert(this.$i18n.t('modal.ChangePassword.Backend.Response.changeFailed'));
                }
            }
        }
    }
}
</script>